import { FYMAPIError } from 'fym-common/src/generics/errors/FYMAPIError';

/** `exists`: the song is in the Catalog already (409). `readOnly`: the artist is above the plan (403). */
export type AddSongErrorKind = 'exists' | 'readOnly' | 'save';

/** The kind of a failed save of the "Add a song" page (design catalog-add-song c3, h3). */
export function addSongErrorOf(error: unknown): AddSongErrorKind {
  if (error instanceof FYMAPIError && error.statusCode === 409) {
    return 'exists';
  }
  if (error instanceof FYMAPIError && error.statusCode === 403) {
    return 'readOnly';
  }
  return 'save';
}
